<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-small-size-66 md-xsmall-size-100 md-medium-size-40 mx-auto"
          >
            <login-card header-color="orange">
              <h4 slot="title" class="card-title">Login</h4>
              <p slot="description" class="description">Go to the management page</p>
              <md-field class="md-form-group" slot="inputs">
                <md-icon>face</md-icon>
                <label>First Name...</label>
                <md-input v-model="firstname"></md-input>
              </md-field>
              <md-field class="md-form-group" slot="inputs">
                <md-icon>lock_outline</md-icon>
                <label>Password...</label>
                <md-input v-model="password" type="password"></md-input>
              </md-field>
              <md-field class="md-form-group" slot="inputs">
                <md-icon>category</md-icon>
                <label>Category</label>
                <md-select v-model="type" name="type" id="type">
                  <md-option value="1">Change MeetingRoom</md-option>
                  <md-option value="2">Change GuestRoom</md-option>
                  <md-option value="3">Meeting Reservation</md-option>
                  <md-option value="4">Guest Reservation</md-option>
                </md-select>
              </md-field>
              <md-button slot="footer" class="md-primary md-lg" @click="submit()">
                Get Started
              </md-button>
            </login-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import axios from 'axios'
export default {
  components: {
    LoginCard
  },
  bodyClass: "login-page",
  data() {
    return {
      firstname: null,
      password: null,
      type: 1
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/slider_img1.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    submit: function () {
      let that = this
      let data = JSON.stringify({"name": that.firstname,"password":that.password});
      // axios.post('/cgi-bin/php/confirmUser.php', data).then((res) => {
      axios.post('https://www.orangetreetx.com/cgi-bin/php/confirmUser.php', data).then((res) => {
        if(res.status === 200 && res.data.result != false) {
          that.$cookies.set("user_session", res.data.result[0])
          // console.log(that.$cookies.get("user_session").name, that.$cookies.get("user_session").password)
          if(that.type == 1) {
            this.$router.push({ path:'/manageMeetingRoom' })
          } else if(that.type == 2) {
            this.$router.push({ path:'/manageGuestRoom' })
          } else if(that.type == 3) {
            this.$router.push({ path:'/meetingHistory' })
          } else if(that.type == 4) {
            this.$router.push({ path:'/guestHistory' })
          }
        } else {
          alert('Can not found username & password!')
        }
      }).catch((error) => {
        console.log(error)
      }).finally((res) => {

      })
    }
  }
};
</script>

<style lang="css" scoped>
.md-select {
  margin-left: 12px;
}
</style>
